import styled from 'styled-components';

import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_IMAGES_ICONS } from 'apps/auth/constants/UrlConstants';
import media from 'apps/auth/theme/media';

/* Steps Screen */
export const StepsListItem = styled.li`
    margin-bottom: 32px;
    display: flex;
`;

/* Pin Create Screen */
export const PinContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 82px;

    ${media.tablet720} {
        margin-top: 72px;
        justify-content: flex-start;
    }
`;

export const PinInputUnderline = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${(props) => props.theme.purple_100};
    opacity: 0;
`;
export const PinInputContainer = styled.div`
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    margin-right: 16px;

    &:last-child {
        margin-right: 0;
    }

    ${media.tablet720} {
        margin-right: 32px;
    }

    input {
        color: inherit;
        width: 48px;
        height: 68px;
        border: 1px solid ${(props) => props.theme.grey_28_tr};
        border-radius: 6px;
        font-size: 24px;
        line-height: 36px;
        text-align: center;

        ${media.tablet720} {
            width: 72px;
            height: 104px;
            border-radius: 8px;
        }
    }

    input:focus + ${PinInputUnderline} {
        opacity: 1;
    }
`;

/* Confirm Address Screen */
export const EnvelopeTop = styled.img`
    width: 100%;
`;
export const Envelope = styled.div`
    background: #ffffff;
    border: 1px solid ${(props) => props.theme.grey_28_tr};
    border-radius: 12px;
    padding: 40px 24px 16px 24px;
    position: relative;
    margin-top: -12px;

    ${media.tablet720} {
        padding: 56px 32px 28px 32px;
    }

    &::after {
        content: '';
        position: absolute;
        background-color: ${(props) => props.theme.purple_100};
        border-radius: 12px 12px 0 0;
        height: 24px;
        left: 24px;
        right: 24px;
        top: -24px;

        ${media.tablet720} {
            height: 32px;
            top: -32px;
        }
    }
`;
export const Address = styled(Text)`
    margin-bottom: 24px;

    ${media.tablet720} {
        margin-bottom: 4px;
    }
`;
export const StampContainer = styled.div`
    position: absolute;
    width: 36px;
    height: 36px;
    bottom: 24px;
    right: 24px;
    display: inline-flex;

    ${media.tablet720} {
        width: 54px;
        height: 54px;
        bottom: 32px;
        right: 32px;
    }
`;

/* Delivery Status Screen */
export const DeliveryStatusList = styled.ul`
    margin-top: 16px;

    ${media.tablet720} {
        margin-top: 24px;
    }
`;
export const DeliveryStatusItem = styled.li`
    padding-left: 40px;
    position: relative;

    & + li {
        padding-top: 48px;
    }

    & + li::before,
    & + li::after {
        background-color: #7633ff;
        content: '';
        position: absolute;
    }

    & + li::before {
        height: 50px;
        left: 11px;
        top: -1px;
        width: 2px;

        ${media.desktop1920} {
            height: 58px;
            top: -5px;
        }
    }

    & + li::after {
        border-radius: 50%;
        height: 22px;
        left: 1px;
        top: 48px;
        width: 22px;

        ${media.desktop1920} {
            top: 53px;
        }
    }
`;

export const DeliveryStatusIconWrap = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    ${media.desktop1920} {
        top: 4px;
    }
`;

export const DeliveryStatusAddress = styled.div`
    margin: 8px 0;
`;

export const DeliveryStatusButton = styled.div`
    padding-left: 16px;
    box-sizing: border-box;
`;

/* Card Activation Screen */
export const Card = styled.div`
    padding: 28px 24px 26px 24px;
    background: ${(props) => props.theme.purple_100};
    border-radius: 12px;
    min-height: 224px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;

    ${media.tablet720} {
        min-height: 304px;
    }
`;
export const CardDigits = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
export const CardDigitsGroup = styled.div`
    width: 25%;
    margin-right: 24px;

    &:last-child {
        margin-right: 0;
        min-width: 72px;
    }

    ${media.desktop1920} {
        min-width: 86px;
    }
`;
export const CardDigitItem = styled.span`
    display: inline-block;
    width: 25%;
    color: ${(props) => props.theme.white_40_tr_base};
    text-align: center;
`;
export const CardFieldLabel = styled.span`
    color: ${(props) => (props.filledInput ? props.theme.white_40_tr_base : props.theme.white_base)};
    font-size: ${(props) => (props.filledInput ? '14px' : '17px')};
    line-height: ${(props) => (props.filledInput ? '20px' : '24px')};
    position: absolute;
    left: 0;
    top: ${(props) => (props.filledInput ? '-22px' : '0')};
    transition: all 0.2s ease-in-out;

    ${media.desktop1920} {
        font-size: ${(props) => (props.filledInput ? '17px' : '20px')};
        line-height: ${(props) => (props.filledInput ? '24px' : '32px')};
        top: ${(props) => (props.filledInput ? '-28px' : '0')};
    }
`;
export const CardFieldContainer = styled.label`
    padding-bottom: 8px;
    color: ${(props) => props.theme.white_base};
    border-bottom: 1px solid ${(props) => props.theme.white_base};
    position: relative;

    input {
        background-color: transparent;
        border: none;
        box-sizing: border-box;
        display: inline-block;
        font-size: 17px;
        line-height: 24px;
        padding: 4px 0 6px;
        width: 100%;
        color: ${(props) => props.theme.white_base};

        ${media.desktop1920} {
            font-size: 20px;
            line-height: 32px;
        }
    }

    input:focus + ${CardFieldLabel} {
        top: -22px;
        font-size: 14px;
        line-height: 20px;
        color: ${(props) => props.theme.white_40_tr_base};

        ${media.desktop1920} {
            font-size: 17px;
            line-height: 24px;
            top: -28px;
        }
    }
`;
export const CardBottom = styled.div`
    display: flex;
    justify-content: space-between;
`;
export const CardName = styled(Text)`
    color: ${(props) => props.theme.white_40_tr_base};
`;
export const CardMastercardLogo = styled.div`
    width: 36px;
    height: 22px;
    background: url(${URL_IMAGES_ICONS}/mastercard-logo_purple-light.svg) no-repeat;
    background-size: cover;

    ${media.desktop1920} {
        width: 50px;
        height: 30px;
    }
`;

/* Payment Method Screen */
export const PanelText = styled.div`
    margin-left: 16px;
`;
